export default {"src":"/_next/static/image/public/images/flags/flag_855.14a8ad6ac641de20d301d428bbbcbfd4.svg","height":16,"width":24};